import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as Arrow } from '../../../../assets/career/arrow-down.svg'
import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
const Select = observer(
  ({
    list,
    defaultValue,
    value,
    setValue,
  }: {
    list: any
    defaultValue: string
    value: string
    setValue: (value: string) => void
  }) => {
    const [show, setShow] = useState(false)
    const ref = useRef<any>(null)

    useEffect(() => {
      if (!ref.current) return
      const inside = (e: any) => {
        if (!ref.current) return
        if (!ref.current.contains(e.target)) {
          setShow(false)
        }
      }

      document.addEventListener('click', inside)

      return () => document.removeEventListener('click', inside)
    }, [])

    return (
      <section
        className="career-select"
        ref={ref}
        onClick={() => setShow(!show)}
      >
        <div
          className={classNames(
            'career-select__top',
            value.length && 'fill',
            show && 'show',
          )}
        >
          <input value={value.length ? value : defaultValue} disabled />
          <Arrow />
        </div>
        <div
          className={classNames('career-select__list', show && 'show')}
          onClick={(e) => e.stopPropagation()}
        >
          <div>
            {list.map((l: any, i: number) => (
              <div
                className="career-select__item"
                key={i}
                onClick={() => {
                  setValue(l)
                  setShow(false)
                }}
              >
                {l}
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  },
)

export default Select
